<footer>
    <div>
        <a href="#top"><img src="/assets/to_top.png" /></a>
    </div>
    <p class="text-xs-center">Site réalisé en Angular couplé à Bootstrap.</p>
    <p class="text-xs-center">Auteur: Coleau Hugo </p>
    <p class="text-xs-center">© Copyright 2021. All rights reserved.</p>
</footer>